// Homepage Component JavaScript - Neo-Brutalist Design

export function init() {
    console.log('Homepage component initialized');

    // Initialize SMS toggle
    initSMSToggle();

    // Initialize pricing selector
    initPricingSelector();

    // Initialize reminder form
    initReminderForm();

    // Initialize FAQ accordion
    initFAQAccordion();

    // Set minimum date to today
    setMinDate();
}

function initSMSToggle() {
    const toggle = document.getElementById('sms-toggle');
    const smsContent = document.getElementById('sms-content');

    if (!toggle || !smsContent) return;

    toggle.addEventListener('click', () => {
        const isActive = toggle.classList.toggle('active');
        toggle.setAttribute('aria-pressed', isActive);

        if (isActive) {
            smsContent.classList.remove('hidden');
        } else {
            smsContent.classList.add('hidden');
        }
    });
}

function initPricingSelector() {
    const pricingOptions = document.querySelectorAll('.pricing-option');

    pricingOptions.forEach(option => {
        option.addEventListener('click', () => {
            // Remove active state from all options
            pricingOptions.forEach(opt => {
                opt.classList.remove('active');
                opt.style.background = 'transparent';
                opt.style.color = '#FAFAFA';
                opt.style.fontWeight = '500';
            });

            // Add active state to clicked option
            option.classList.add('active');
            option.style.background = '#FFE135';
            option.style.color = '#121212';
            option.style.fontWeight = '700';
        });
    });
}

function initReminderForm() {
    const form = document.getElementById('reminder-form');
    const submitBtn = document.getElementById('submit-btn');

    if (!form || !submitBtn) return;

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        // Validate inputs
        const loanName = document.getElementById('loan-name');
        const dueDate = document.getElementById('due-date');
        const email = document.getElementById('email');

        let hasError = false;

        // Clear previous errors
        [loanName, dueDate, email].forEach(input => {
            input.classList.remove('error');
        });

        // Validate each field
        if (!loanName.value.trim()) {
            loanName.classList.add('error');
            hasError = true;
        }

        if (!dueDate.value) {
            dueDate.classList.add('error');
            hasError = true;
        }

        if (!email.value || !isValidEmail(email.value)) {
            email.classList.add('error');
            hasError = true;
        }

        if (hasError) {
            showMessage('Please fill in all required fields correctly.', 'error');
            return;
        }

        // Show loading state
        submitBtn.disabled = true;
        submitBtn.textContent = 'Setting...';

        // Simulate API call
        setTimeout(() => {
            // Success state
            submitBtn.classList.add('success');
            submitBtn.textContent = 'SAVED!';

            // Store reminder in localStorage for demo
            const reminders = JSON.parse(localStorage.getItem('reminders') || '[]');
            reminders.push({
                loanName: loanName.value,
                dueDate: dueDate.value,
                email: email.value,
                smsEnabled: document.getElementById('sms-toggle').classList.contains('active'),
                phone: document.getElementById('phone')?.value || '',
                createdAt: new Date().toISOString()
            });
            localStorage.setItem('reminders', JSON.stringify(reminders));

            // Show success message
            showMessage(`We'll remind you about "${loanName.value}" on ${formatDate(dueDate.value)}!`, 'success');

            // Reset after delay
            setTimeout(() => {
                submitBtn.classList.remove('success');
                submitBtn.textContent = 'Set Reminder';
                submitBtn.disabled = false;
                form.reset();

                // Reset SMS toggle
                const toggle = document.getElementById('sms-toggle');
                const smsContent = document.getElementById('sms-content');
                if (toggle && smsContent) {
                    toggle.classList.remove('active');
                    toggle.setAttribute('aria-pressed', 'false');
                    smsContent.classList.add('hidden');
                }
            }, 1500);
        }, 800);
    });

    // Add focus/blur effects to inputs
    const inputs = form.querySelectorAll('.input-field');
    inputs.forEach(input => {
        input.addEventListener('focus', () => {
            input.classList.remove('error');
        });
    });
}

function setMinDate() {
    const dueDateInput = document.getElementById('due-date');
    if (dueDateInput) {
        dueDateInput.min = new Date().toISOString().split('T')[0];
    }
}

function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

function showMessage(message, type = 'success') {
    const messageBox = document.getElementById('message-box');
    const messageText = document.getElementById('message-text');

    if (!messageBox || !messageText) return;

    messageText.textContent = message;

    // Update colors based on type
    const container = messageBox.querySelector('div');
    if (type === 'error') {
        container.style.backgroundColor = '#FF4D4D';
        container.style.color = '#FAFAFA';
    } else {
        container.style.backgroundColor = '#A4F65D';
        container.style.color = '#121212';
    }

    messageBox.classList.remove('hidden');

    // Hide after delay
    setTimeout(() => {
        messageBox.classList.add('hidden');
    }, 5000);
}

function showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
        toast.classList.add('fade-out');
        setTimeout(() => toast.remove(), 500);
    }, 3000);
}

function initFAQAccordion() {
    const faqToggles = document.querySelectorAll('.faq-toggle');
    console.log('Initializing FAQ accordion with', faqToggles.length, 'toggles');

    faqToggles.forEach((toggle, index) => {
        console.log('Setting up FAQ toggle', index);
        
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            console.log('FAQ toggle clicked');
            
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            const content = toggle.nextElementSibling;

            if (!content) {
                console.error('Content element not found for toggle', index);
                return;
            }

            // Close all other FAQs (exclusive behavior)
            faqToggles.forEach(otherToggle => {
                if (otherToggle !== toggle) {
                    const isOtherExpanded = otherToggle.getAttribute('aria-expanded') === 'true';
                    if (isOtherExpanded) {
                        otherToggle.setAttribute('aria-expanded', 'false');
                        const otherContent = otherToggle.nextElementSibling;
                        if (otherContent) {
                            otherContent.classList.add('hidden');
                            otherContent.style.maxHeight = '0';
                            otherContent.style.paddingTop = '0';
                            otherContent.style.paddingBottom = '0';
                        }
                    }
                }
            });

            // Toggle current FAQ
            if (isExpanded) {
                console.log('Closing FAQ', index);
                toggle.setAttribute('aria-expanded', 'false');
                content.classList.add('hidden');
                content.style.maxHeight = '0';
                content.style.paddingTop = '0';
                content.style.paddingBottom = '0';
            } else {
                console.log('Opening FAQ', index);
                toggle.setAttribute('aria-expanded', 'true');
                content.classList.remove('hidden');
                content.style.maxHeight = '500px';
                content.style.paddingTop = '1rem';
                content.style.paddingBottom = '1.5rem';
            }
        });
    });
}

// Export individual functions for testing or external use
export {
    initSMSToggle,
    initPricingSelector,
    initReminderForm,
    initFAQAccordion,
    showToast,
    showMessage
};
